import { getPolygonInteriorLonLat } from '../components/DrawingUtils';
import { pointInFarmGeometry } from './geometry/pointInPolygon';

type GeoFeature = {
  type?: string;
  geometry?: { type?: string; coordinates?: unknown };
};

type FeatureCollection = {
  type?: string;
  features?: GeoFeature[];
};

function featureLonLat(feat: GeoFeature): [number, number] | null {
  const geom = feat?.geometry;
  if (!geom?.type || !geom.coordinates) return null;
  try {
    const pt = getPolygonInteriorLonLat({ type: 'Feature', geometry: geom });
    if (pt && Number.isFinite(pt[0]) && Number.isFinite(pt[1])) {
      return [pt[0], pt[1]];
    }
  } catch {
    /* fall through */
  }
  return null;
}

/**
 * Delineation block indices whose interior point falls inside any saved farm polygon.
 */
export function findDelineationIndicesOverlappingSavedFields(
  delineation: FeatureCollection,
  savedFields: FeatureCollection
): number[] {
  const detections = Array.isArray(delineation?.features) ? delineation.features : [];
  const saved = Array.isArray(savedFields?.features) ? savedFields.features : [];
  if (!detections.length || !saved.length) return [];

  const savedGeoms = saved.map((f) => f?.geometry).filter(Boolean);
  const overlap: number[] = [];

  detections.forEach((feat, index) => {
    const lonLat = featureLonLat(feat);
    if (!lonLat) return;
    const [lon, lat] = lonLat;
    if (savedGeoms.some((geom) => pointInFarmGeometry(lon, lat, geom))) {
      overlap.push(index);
    }
  });

  return overlap;
}
